// src/merchant/MerchantRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import Loader from '../components/Loader';

export default function MerchantRoute({ children }) {
  const { user, loading } = useApp();

  if (loading) return <Loader fullPage />;

  // Not logged in → go to login
  if (!user) return <Navigate to="/login" replace />;

  // Logged in but not merchant/admin → go home silently
  if (user.role !== 'merchant' && user.role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  return children;
}
